import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Hero.css";
import Card from "../Components/Card";
import { fetchProfiles } from "../lib/profileApi";
//import ColorBends from "../Components/ColorBends";
import Footer from "../Components/Footer";
import Counter from "../Components/Counter";

const Hero = () => {
  const location = useLocation();
  const [profiles, setProfiles] = useState([]);
  const [isLoadingProfiles, setIsLoadingProfiles] = useState(true);
  const [profilesError, setProfilesError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(3);
  const [isSmallDevice, setIsSmallDevice] = useState(false);

  const normalizedQuery = searchQuery.trim().toLowerCase();
  const filteredCards = profiles.filter((card) => {
    const matchesSearch =
      !normalizedQuery ||
      card.name.toLowerCase().includes(normalizedQuery) ||
      card.location.toLowerCase().includes(normalizedQuery);

    const matchesCategory =
      !selectedCategory ||
      card.service.toLowerCase() === selectedCategory.toLowerCase();

    return matchesSearch && matchesCategory;
  });

  useEffect(() => {
    const loadProfiles = async () => {
      try {
        setIsLoadingProfiles(true);
        setProfilesError("");
        const result = await fetchProfiles();
        setProfiles(result);
      } catch (error) {
        setProfilesError(error.message);
      } finally {
        setIsLoadingProfiles(false);
      }
    };

    loadProfiles();
  }, []);

  useEffect(() => {
    const updateCardsPerView = () => {
      if (window.innerWidth < 768) {
        setCardsPerView(1);
        setIsSmallDevice(true);
        return;
      }

      setCardsPerView(3);
      setIsSmallDevice(false);
    };

    updateCardsPerView();
    window.addEventListener("resize", updateCardsPerView);

    return () => window.removeEventListener("resize", updateCardsPerView);
  }, []);

  const maxIndex = Math.max(filteredCards.length - cardsPerView, 0);

  useEffect(() => {
    if (activeIndex > maxIndex) {
      setActiveIndex(maxIndex);
    }
  }, [activeIndex, maxIndex]);

  useEffect(() => {
    setActiveIndex(0);
  }, [searchQuery]);

  useEffect(() => {
    if (sessionStorage.getItem("scrollToFooter") !== "true") {
      return;
    }

    const timer = window.setTimeout(() => {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
      });
      sessionStorage.removeItem("scrollToFooter");
    }, 100);

    return () => window.clearTimeout(timer);
  }, [location.key]);

  const handlePrevious = () => {
    setActiveIndex((current) => Math.max(current - 1, 0));
  };

  const handleNext = () => {
    setActiveIndex((current) => Math.min(current + 1, maxIndex));
  };

  return (
    <div className="hero-wrapper">
      <div id="hero" className="hero pb-4">
        {/* 
        <ColorBends
  colors={["#ff5c7a", "#8a5cff", "#00ffd1"]}
  rotation={0}
  speed={0.2}
  scale={1}
  frequency={1}
  warpStrength={1}
  mouseInfluence={1}
  parallax={0.5}
  noise={0.1}
  transparent
  autoRotate={0}
  color=""
/> */}

     <div className="search-wrapper">
 
  <input
    className="search"
    type="text"
    placeholder="Search by Region, City o Name"
    value={searchQuery}
    onChange={(event) => setSearchQuery(event.target.value)}
  />
   <span className="search-icon">🔍</span>
</div>
      </div>
      {(!isSmallDevice || searchQuery === "") && <div className="description">Let's Link Up If You In Town</div>}

      <div className="container pb-5">
        <div className="row align-items-start g-4">
          <div className="col-12 col-lg-5">
            <h4 className="mb-4 text-light text-center">Search By Category</h4>
            <div className="buttons d-flex flex-wrap gap-3">
              <button
                onClick={() => setSelectedCategory("Therapy")}
                className="btn category-btn"
              >
                Therapy
              </button>
              <button
                onClick={() => setSelectedCategory("massage")}
                className="btn  category-btn"
              >
                Massage
              </button>
              <button
                onClick={() => setSelectedCategory("Tour Guide")}
                className="btn category-btn"
              >
                Tour Guide
              </button>
              <button
                onClick={() => setSelectedCategory("Companion Service")}
                className="btn  category-btn"
              >
                Companion
              </button>
            </div>
          </div>
          {(!isSmallDevice || searchQuery === "") &&
            <div className="col-12 col-lg-7">
            <iframe
              className="g-map"
              title="ghana"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2028663.972741346!2d-2.666160068061574!3d6.741246537893835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdb96ebefbe0563%3A0xb6f9278ff121292b!2sRegione%20di%20Ashanti%2C%20Ghana!5e0!3m2!1sit!2sit!4v1776102903166!5m2!1sit!2sit"
              width="600"
              height="450"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          }
          
        </div>
      </div>
      <div className="container-fluid pb-5">
        <div className="cards-section">
          <div className="cards-header">
            <div>
              <h3 className="text-light cards-title">Featured profiles</h3>
              <p className="cards-subtitle">
                Browse the latest cards with arrow controls.
              </p>
            </div>
          </div>

          <div className="cards-viewport">
            {isLoadingProfiles ? (
              <div className="cards-empty-state">Loading profiles...</div>
            ) : profilesError ? (
              <div className="cards-empty-state">{profilesError}</div>
            ) : filteredCards.length > 0 ? (
              <div
                className="cards-track"
                style={{
                  transform: `translateX(-${(100 / cardsPerView) * activeIndex}%)`,
                }}
              >
                {filteredCards.map((card) => (
                  <div
                    key={card.id}
                    className="carousel-card"
                    style={{ flex: `0 0 ${100 / cardsPerView}%` }}
                  >
                    <Card
                      id={card.id}
                      name={card.name}
                      location={card.location}
                      image={card.image}
                      service={card.service}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="cards-empty-state">
                No profiles match that name or location.
              </div>
            )}
          </div>
          <div className="cards-controls">
            <button
              type="button"
              className="carousel-arrow"
              onClick={handlePrevious}
              disabled={activeIndex === 0}
              aria-label="Previous cards"
            >
              &#8592;
            </button>
            <button
              type="button"
              className="carousel-arrow"
              onClick={handleNext}
              disabled={activeIndex === maxIndex}
              aria-label="Next cards"
            >
              &#8594;
            </button>
          </div>
        </div>
      </div>
      <div className="contatore py-4 my-5">
        <Counter target={50000} />

      </div>
      

      <Footer />
    </div>
  );
};

export default Hero;
